import Avatar from './avatar'
import AvatarGroup from './avatar-group'

Avatar.Group = AvatarGroup

export default Avatar
